import React from 'react';

import PropTypes from 'prop-types';
import {FormikErrors, withFormik} from 'formik';

import {FieldShape} from 'commons/shapes';
import {CONSTANT_VALUES} from 'commons/constants';
import InnerFormAddress from './InnerFormAddress';
import {InferPropTypes} from 'commons/types/Types';
import {AddressServiceRequest} from 'commons/models';
import {formValidator} from 'commons/utils/Functions';

BeneficiaryAddressForm.propTypes = {
    viewId: PropTypes.number.isRequired,
    viewKey: PropTypes.string.isRequired,
    fieldHandler: PropTypes.func.isRequired,
    submitHandler: PropTypes.func.isRequired,
    foreignCitizen: PropTypes.bool.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    auxBeneficiary: PropTypes.any,
};

const FormControl = withFormik<
    InferPropTypes<typeof BeneficiaryAddressForm.propTypes>,
    AddressServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            expedientId: '',
            workflowId: '',
            viewId: '',
            viewFatherId: '',
            kycId: '',
            addressId: '',
            streetDescription: '',
            addressDescription: '',
            outdoorNumber: '',
            interiorNumber: '',
            zipCode: '',
            colonyKey: '',
            colonyDescription: '',
            municipalityKey: '',
            municipalityDescription: '',
            stateKey: '',
            stateDescription: '',
            countryKey: '',
            hasNext: '',
        };
    },
    mapPropsToValues: (props) => {
        const {auxBeneficiary} = props;
        if (auxBeneficiary) {
            return {
                expedientId: auxBeneficiary.expedientId || 0,
                workflowId: auxBeneficiary.workflowId || 0,
                viewId: auxBeneficiary.viewId || 0,
                viewFatherId: auxBeneficiary.viewFatherId || 0,
                kycId: auxBeneficiary.kycId || 0,
                addressId: auxBeneficiary.addressId || 1,
                streetDescription: auxBeneficiary.streetDescription || '',
                addressDescription: auxBeneficiary.addressDescription || '',
                outdoorNumber: auxBeneficiary.outdoorNumber || '',
                interiorNumber: auxBeneficiary.interiorNumber || '',
                zipCode: auxBeneficiary.zipCode || '',
                colonyKey: auxBeneficiary.colonyKey || '',
                colonyDescription: auxBeneficiary.colonyDescription || '',
                municipalityKey: auxBeneficiary.municipalityKey || '',
                municipalityDescription: auxBeneficiary.municipalityDescription || '',
                stateKey: auxBeneficiary.stateKey || '',
                stateDescription: auxBeneficiary.stateDescription || '',
                countryKey: auxBeneficiary.countryKey || '',
                hasNext: auxBeneficiary.hasNext || false,
            };
        } else {
            return {
                expedientId: 0,
                workflowId: 0,
                viewId: 0,
                viewFatherId: 0,
                kycId: 0,
                addressId: null,
                streetDescription: '',
                addressDescription: '',
                outdoorNumber: '',
                interiorNumber: '',
                zipCode: '',
                colonyKey: '',
                colonyDescription: '',
                municipalityKey: '',
                municipalityDescription: '',
                stateKey: '',
                stateDescription: '',
                countryKey: props.foreignCitizen ? '' : CONSTANT_VALUES.MexicoId,
                hasNext: false,
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: AddressServiceRequest, props) => {
        const errors: FormikErrors<AddressServiceRequest> = {};
        formValidator(props.fields, errors, values);
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormAddress);

function BeneficiaryAddressForm(props: InferPropTypes<typeof BeneficiaryAddressForm.propTypes>) {
    const {submitHandler, fields, viewId, auxBeneficiary, fieldHandler, foreignCitizen, viewKey} =
        props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            viewId={viewId}
            fields={fields}
            foreignCitizen={foreignCitizen}
            fieldHandler={fieldHandler}
            viewKey={viewKey}
            submitHandler={submitHandler}
            auxBeneficiary={auxBeneficiary}
        />
    );
}

export default BeneficiaryAddressForm;
